import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface AspectLinkProps {
	aspectName: string
}

export function AspectLink(props: AspectLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		<React.Fragment>
			{
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<a className='filter spirit-aspect' href='#' onClick={(e) => {
					e.preventDefault()
					addFilter('aspects', props.aspectName)
				}}>
					{props.aspectName}
				</a>
			}
		</React.Fragment>
	)
}
